import type { HTMLAttributes } from 'react';
import { cn } from '../../lib/utils';

/** Surface panel — the standard container for grouped content. */
export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('rounded-md border border-hairline bg-surface shadow-card', className)}
      {...props}
    />
  );
}
